const INACTIVE_WIDTH = 192;
const INACTIVE_WIDTH_LOGIN_ONLY = 142;
const INACTIVE_HEIGHT = 32;
const ACTIVE_WIDTH = 412;
const LOGIN_WIDTH = 452;
const ACTIVE_CONTENT_PADDING = 8;
const LOGIN_CONTENT_PADDING = 20;
const TOOL_BAR_TO_ACTIVE_CONTENT_SPACE = 8;
const INNER_MENU_BORDER_RADIUS = 10;
const ACITVE_CONTENT_PADDING_BOTTOM = 24;
const TOOLBAR_MARGIN = 16;
const TOOLBAR_PADDING_X = 6;

export {
  INACTIVE_WIDTH,
  INACTIVE_WIDTH_LOGIN_ONLY,
  INACTIVE_HEIGHT,
  ACTIVE_WIDTH,
  LOGIN_WIDTH,
  ACTIVE_CONTENT_PADDING,
  LOGIN_CONTENT_PADDING,
  TOOL_BAR_TO_ACTIVE_CONTENT_SPACE,
  INNER_MENU_BORDER_RADIUS,
  ACITVE_CONTENT_PADDING_BOTTOM,
  TOOLBAR_MARGIN,
  TOOLBAR_PADDING_X,
};
